import styled from 'styled-components/macro';
import { defaultContainer } from '../../styles/utils';

export const CommissionPayoutsDiv = styled.div`
  ${defaultContainer}
`;

export const CommissionPayoutsHeaderDiv = styled.div`
  padding-top: 5rem;
  @media screen and (max-width: 767px) {
    margin-left: -2rem;
    p {
      padding-left: 2rem;
    }
  }
`;

export const HeaderTextDiv = styled.div`
  margin-top: 25px;
  margin-bottom: 20px;
`;
